import React from 'react';
import '../../../../../assets/css/phieuin-kiemkequy.css';
import { parseMenhGia } from "../../../../../utils/kiemkeUtils";
import { formatNumber2 } from "../../../../../utils/currencyFormat"
export const PhieuIn = React.forwardRef(({ item }, ref) => {
    const chiTietKiemKe = item.ChiTiet || [];
    const totalThucTe = item.TotalKiemKe || 0;
    const quyHeThong = item.QuyTienMat || 0;
    const chenhLech = totalThucTe - quyHeThong;
    const ngayKiemKe = item.CreateTime ? new Date(item.CreateTime).toLocaleString('vi-VN', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
    }) : '';
    let tongTienMat = 0;
    let tongNganHang = 0;
    chiTietKiemKe.forEach(chiTiet => {
        if (chiTiet.LoaiTienTe === false) {
            const menhGiaValue = parseMenhGia(chiTiet.MenhGia);
            tongTienMat += menhGiaValue * (chiTiet.SoLuong || 0);
        } else {
            tongNganHang += chiTiet.SoLuong || 0;
        }
    });

    return (
        <div ref={ref} className="print-page">
            <h2 className="print-title">BIÊN BẢN KIỂM KÊ QUỸ VÀ TIỀN GỬI NGÂN HÀNG TỒN</h2>

            <div className="print-top-section">
                <div className="print-column">
                    <p><strong>Ngày kiểm kê:</strong> {ngayKiemKe}</p>
                    <p><strong>Người kiểm kê:</strong> {item.NguoiTao || ''}</p>
                    <p><strong>Lý do chênh lệch:</strong> {item.GhiChu || ''}</p>
                </div>
                <div className="print-column">
                    <p><strong>Tổng quỹ hệ thống:</strong> {formatNumber2(quyHeThong)}</p>
                    <p><strong>Tổng thực tế:</strong> {formatNumber2(totalThucTe)}</p>
                    <p><strong>Chênh lệch:</strong> {formatNumber2(chenhLech)}</p>
                </div>
            </div>

            <div className="print-summary-section">
                <p><strong>Tổng tiền mặt:</strong> {formatNumber2(tongTienMat)}</p>
                <p><strong>Tổng ngân hàng:</strong> {formatNumber2(tongNganHang)}</p>
            </div>
            
            <table className="print-table">
                <thead>
                    <tr>
                        <th style={{width: '5%'}}>STT</th>
                        <th style={{width: '20%'}}>LOẠI CHI TIẾT</th>
                        <th style={{width: '30%'}}>MỆNH GIÁ / NGÂN HÀNG</th>
                        <th style={{width: '20%'}}>SỐ LƯỢNG (TỜ)</th>
                        <th style={{width: '25%'}}>THÀNH TIỀN</th>
                    </tr>
                </thead>
                <tbody>
                     {chiTietKiemKe.length > 0 ? chiTietKiemKe.map((chiTiet, index) => {
                         let thanhTien = 0;
                         if (chiTiet.LoaiTienTe === false) {
                            const menhGiaValue = parseMenhGia(chiTiet.MenhGia);
                            thanhTien = menhGiaValue * (chiTiet.SoLuong || 0);
                         } else {
                            thanhTien = chiTiet.SoLuong || 0;
                         }
                         return (
                             <tr key={index}>
                                 <td className="td-center">{index + 1}</td>
                                 <td>{chiTiet.LoaiTienTe === false ? 'Tiền mặt' : 'Ngân hàng'}</td>
                                 <td>{chiTiet.MenhGia}</td>
                                 <td className="td-right">{chiTiet.LoaiTienTe === false ? formatNumber2(chiTiet.SoLuong) : 0}</td>
                                 <td className="td-right">{formatNumber2(thanhTien)}</td>
                             </tr>
                         );
                     }) : (
                        <tr>
                            <td colSpan="5" style={{textAlign: 'center'}}>Không có dữ liệu chi tiết.</td>
                        </tr>
                     )}
                </tbody>
            </table>
            
            <div className="print-signature-area">
                <div className="print-signature-row">
                    <div className="print-signature-block"></div>
                    <div className="print-signature-block">
                        <p className="print-signature-date">Ngày ..... tháng ..... năm .....</p>
                    </div>
                </div>

                <div className="print-signature-row">
                    <div className="print-signature-block signature-padding">
                        <p className="print-signature-title">Trưởng cửa hàng</p>
                        <p className="print-signature-subtitle">(Ký, họ tên)</p>
                    </div>
                    <div className="print-signature-block signature-padding">
                        <p className="print-signature-title">Thủ quỹ</p>
                        <p className="print-signature-subtitle">(Ký, họ tên)</p>
                    </div>
                </div>
            </div>
        </div>
    );
});

